module.exports = __webpack_public_path__ + "static/New_Hero_SemiBold-8cdc4823cc2aba300aa56a37dedb945d.otf";